module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "base-detail",
    style: (_vm.detailStyle),
    attrs: {
      "id": "detail"
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("基地详情")]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/16.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem.name))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../../../../static/img/recordInformation/13.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem.address))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('img', {
    staticClass: "img2",
    attrs: {
      "src": require("../../../../static/img/recordInformation/14.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem.manager))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../../../../static/img/recordInformation/15.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem.year))])])]), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('el-amap', {
    ref: "map",
    staticClass: "map",
    attrs: {
      "vid": "amapDemo",
      "zoom": _vm.zoom,
      "center": _vm.center,
      "plugin": _vm.plugin,
      "amap-manager": _vm.amapManager,
      "events": _vm.events
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("企业信息介绍")]), _vm._v(" "), _c('div', {
    staticClass: "list1"
  }, [_c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem1.name))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../../../../static/img/recordInformation/12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem1.address))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img2",
    attrs: {
      "src": require("../../../../static/img/recordInformation/6.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem1.phone))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("入网企业")]), _vm._v(" "), _c('span', [_vm._v("201个")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("智能硬件设备个数")]), _vm._v(" "), _c('span', [_vm._v("40个")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("追溯产品")]), _vm._v(" "), _c('span', [_vm._v("71种")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item list-item1"
  }, [_c('img', {
    staticClass: "img3",
    attrs: {
      "src": require("../../../../static/img/recordInformation/7.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("可追溯商品 12 种")]), _vm._v(" "), _c('div', {
    staticClass: "trace-pro"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/pic1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/pic2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/pic3.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img2",
    attrs: {
      "src": require("../../../../static/img/recordInformation/10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("溯源基地 2 个")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/8.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("气象设备2台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../../../../static/img/recordInformation/9.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("监控设备14台")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-212c1a16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recordInformation/center/index.vue
// module id = 1957
// module chunks = 2